import { IEntity } from '@pf/shared-common';
import {
    ItemFragment,
    ReplenishmentPriority,
    ReplenishmentSearchRequestParams,
    ReplenishmentStatus,
    ReplenishmentViewModelCreateBody,
    ReplenishmentViewModelRead,
    ResourceAuth,
    SlotFragment,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import { UserFragment } from '@control-tower/platform-core';

export type ReplenishmentRead = ReplenishmentViewModelRead & IEntity;
export type ReplenishmentCreate = ReplenishmentViewModelCreateBody;
export type ReplenishmentSearchParams = ReplenishmentSearchRequestParams;

export class ReplenishmentDto implements IEntity {
    constructor(data: Partial<ReplenishmentDto>) {
        Object.assign(this, data);
    }

    id!: string;
    warehouseId!: string;
    warehouse!: WarehouseFragment;
    item?: ItemFragment;
    itemId?: string;
    replenishToSlotId?: string;
    replenishToSlot?: SlotFragment;
    replenishFromSlotId?: string;
    replenishFromSlot?: SlotFragment;
    quantityNeeded?: number | null;
    quantityReplenished?: number | null;
    assignedToUserId?: string;
    assignedToUser?: UserFragment;
    replenishedDate?: string;
    inventoryAdjustmentId?: string;
    status?: ReplenishmentStatus;
    priority?: ReplenishmentPriority;

    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    resourceAuth?: ResourceAuth;
}
